
import * as data from './data'

const install = function (Vue) {
  if (install.installed) return
  install.installed = true

  //定义属性到Vue原型中
  Object.defineProperties(Vue.prototype, {
    $fetch: {
      get() {
        return data
      }
    }
  })
}

export default {
  install
}


// WEBPACK FOOTER //
// ./src/api/index.js